export class Constants {
  public static readonly COCOON_CONDITIONS = 'COCOON_116_IS_DISABLED_BY_REQUEST_3674';
}
